// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_24H","cls2":"SimplePaperPodcast-cls2_nli SimplePaperPodcast-cls1_24H"};